// Import necessary styles and libraries
import { createApp } from 'vue';
import Purchases from "./Purchases.vue";
import { i18n } from '../../i18n';

// Check if the specific element exists in the DOM
if (document.querySelector('#purchases')) {
  // Create a new Vue instance and mount it to the element
  const app = createApp(Purchases);
  app.use(i18n);
  app.mount('#purchases');
  window.purchaseVueAppMounted = true;
}
